import dayjs, { Dayjs } from "dayjs";
import { useTranslation } from "react-i18next";
import { DateRange } from "@/domains/common";
// components
import { Radio, RadioChangeEvent } from "antd";

export type DateRangeRadioGroupChangeEvent = (
  dateRange: DateRange,
  getDateRange?: () => Dayjs[]
) => void;

export interface DateRangeRadioGroupProps {
  dateRange: DateRange;
  onChange: DateRangeRadioGroupChangeEvent;
}

export const DateRangeRadioGroup = ({
  dateRange,
  onChange,
}: DateRangeRadioGroupProps) => {
  const { t } = useTranslation();

  const dateRangeButtons = [
    {
      label: t("systems.Date.dateRanges.day0"),
      value: DateRange.day0,
      getDateRange: () => [dayjs().startOf("day"), dayjs().endOf("day")],
    },
    {
      label: t("systems.Date.dateRanges.day1"),
      value: DateRange.day1,
      getDateRange: () => [
        dayjs().subtract(1, "day").startOf("day"),
        dayjs().subtract(1, "day").endOf("day"),
      ],
    },
    {
      label: t("systems.Date.dateRanges.week0"),
      value: DateRange.week0,
      getDateRange: () => [dayjs().startOf("week"), dayjs().endOf("week")],
    },
    {
      label: t("systems.Date.dateRanges.week1"),
      value: DateRange.week1,
      getDateRange: () => [
        dayjs().subtract(1, "week").startOf("week"),
        dayjs().subtract(1, "week").endOf("week"),
      ],
    },
    {
      label: t("systems.Date.dateRanges.month0"),
      value: DateRange.month0,
      getDateRange: () => [dayjs().startOf("month"), dayjs().endOf("month")],
    },
    {
      label: t("systems.Date.dateRanges.month1"),
      value: DateRange.month1,
      getDateRange: () => [
        dayjs().subtract(1, "month").startOf("month"),
        dayjs().subtract(1, "month").endOf("month"),
      ],
    },
    {
      label: t("systems.Date.dateRanges.custom"),
      value: DateRange.custom,
    },
  ];

  const handleDateChange = (e: RadioChangeEvent) => {
    const button = dateRangeButtons.find((b) => b.value === e.target.value)!;
    onChange(button.value, button.getDateRange);
  };

  return (
    <Radio.Group value={dateRange} onChange={(e) => handleDateChange(e)}>
      {dateRangeButtons.map((button) => (
        <Radio.Button value={button.value} key={button.value}>
          {button.label}
        </Radio.Button>
      ))}
    </Radio.Group>
  );
};
